import React, { useState } from 'react';
import './App.css';
import { Orders } from './screens/Orders';
import { Drivers } from './screens/Drivers';
import { Map } from './screens/Map';
import { Analytics } from './screens/Analytics';
import { AppNav } from './components/AppNav';
import { Shops } from './screens/Shops';
import { Applications } from './screens/Applications';
import { Settings } from './screens/Settings';
import { LoginPage } from './screens/LoginPage';

import { DataProvider } from './context/DataContext';
import { AuthProvider, useAuth } from './context/AuthContext';

const SCREENS: Record<string, React.FC> = {
  orders: Orders,
  drivers: Drivers,
  map: Map,
  analytics: Analytics,
  shops: Shops,
  applications: Applications,
  settings: Settings,
};

function AdminPanel() {
  const [activeScreen, setActiveScreen] = useState('orders');
  const Screen = SCREENS[activeScreen] ?? Orders;

  return (
    <DataProvider>
      <div className="App">
        <AppNav activeTab={activeScreen} onTabChange={setActiveScreen} />
        <main className="shell__main">
          <Screen />
        </main>
      </div>
    </DataProvider>
  );
}

function AppGate() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner" />
      </div>
    );
  }

  return isAuthenticated ? <AdminPanel /> : <LoginPage />;
}

function App() {
  return (
    <AuthProvider>
      <AppGate />
    </AuthProvider>
  );
}

export default App;
